import { useEffect, useState } from 'react';

/**
 * Sparkles（Aceternity UI 风格，轻量 CSS 版）— 闪烁星点
 */
export function Sparkles({ count = 24, className = '' }: { count?: number; className?: string }) {
  const [dots, setDots] = useState<React.CSSProperties[]>([]);

  useEffect(() => {
    const next = Array.from({ length: count }).map(() => ({
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      animationDelay: `${(Math.random() * 3).toFixed(2)}s`,
      animationDuration: `${(Math.random() * 2 + 2).toFixed(2)}s`,
      width: `${Math.random() * 2 + 1}px`,
      height: `${Math.random() * 2 + 1}px`,
    }));
    setDots(next);
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {dots.map((style, i) => (
        <span key={i} className="absolute rounded-full bg-white animate-twinkle" style={style} />
      ))}
    </div>
  );
}
